const rosterStatusToSpanish = {
  CREATED: 'Creada',
  PROCESSING: 'Procesando recesion',
  RECEDED: 'Recedida',
  COMPLETED: 'Recesión completa',
  PAID: 'Giro recibido',
};

export default rosterStatusToSpanish;
